import { render, staticRenderFns } from "./3.vue?vue&type=template&id=1f331ee7&scoped=true"
import script from "./3.vue?vue&type=script&lang=js"
export * from "./3.vue?vue&type=script&lang=js"
import style0 from "./3.vue?vue&type=style&index=0&id=1f331ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f331ee7",
  null
  
)

export default component.exports